import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, className = "", as = "div" }) {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
    >
      {children}
    </Tag>
  );
}

export function Chapter({ number, label, title, description, center = false, light = false }) {
  return (
    <div className={center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <FadeUp>
        <p className={`flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] ${center ? "justify-center" : ""} ${light ? "text-white/60" : "text-primary"}`}>
          <span className={`font-display text-sm font-light ${light ? "text-white/40" : "text-ink/30"}`}>{number}</span>
          <span className={`h-px w-8 ${light ? "bg-white/30" : "bg-primary/40"}`} aria-hidden="true" />
          {label}
        </p>
      </FadeUp>
      <FadeUp delay={0.08}>
        <h2 className={`mt-5 font-display text-3xl font-medium leading-tight tracking-tight md:text-4xl lg:text-5xl ${light ? "text-white" : "text-ink"}`}>
          {title}
        </h2>
      </FadeUp>
      {description && (
        <FadeUp delay={0.16}>
          <p className={`mt-5 text-base leading-relaxed md:text-lg ${light ? "text-white/70" : "text-muted-foreground"}`}>{description}</p>
        </FadeUp>
      )}
    </div>
  );
}

export function CTAButton({ to, children, testid, variant = "primary", className = "" }) {
  const styles =
    variant === "primary"
      ? "bg-primary text-white hover:bg-energy-light"
      : variant === "white"
        ? "bg-white text-energy-deep hover:bg-energy-pale"
        : "border border-ink/15 text-ink hover:border-primary hover:text-primary";
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`group inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-bold transition-colors duration-200 md:text-base ${styles} ${className}`}
    >
      {children}
      <ArrowUpRight size={18} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </Link>
  );
}

export function CTABand() {
  return (
    <section data-testid="cta-band" className="bg-primary">
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-end">
          <div className="max-w-2xl">
            <FadeUp>
              <p className="text-xs font-bold uppercase tracking-[0.24em] text-white/60">Aan de slag</p>
            </FadeUp>
            <FadeUp delay={0.08}>
              <h2 className="mt-5 font-display text-3xl font-medium leading-tight tracking-tight text-white md:text-5xl">
                Klaar om uw energielabel aan te vragen?
              </h2>
            </FadeUp>
            <FadeUp delay={0.16}>
              <p className="mt-5 text-base leading-relaxed text-white/80 md:text-lg">
                Vul in twee minuten het aanvraagformulier in. Wij nemen daarna snel contact met u op om de opname in te plannen.
              </p>
            </FadeUp>
          </div>
          <FadeUp delay={0.2} className="shrink-0">
            <CTAButton to="/aanvragen" testid="cta-band-button" variant="white">
              Energielabel aanvragen
            </CTAButton>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
